import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { MobileNav } from "@/components/MobileNav";
import { FavoritesProvider } from "@/context/FavoritesContext";
import HomePage from "@/pages/HomePage";
import LaunchesPage from "@/pages/LaunchesPage";
import LaunchDetailPage from "@/pages/LaunchDetailPage";
import NewsPage from "@/pages/NewsPage";
import ISSPage from "@/pages/ISSPage";
import MoonPage from "@/pages/MoonPage";
import WeatherPage from "@/pages/WeatherPage";
import WatchlistPage from "@/pages/WatchlistPage";

function App() {
  const [zipCode, setZipCode] = useState(() => {
    return localStorage.getItem("florida_zip") || "32920";
  });

  useEffect(() => {
    localStorage.setItem("florida_zip", zipCode);
  }, [zipCode]);

  return (
    <div className="min-h-screen bg-space-black">
      {/* Grain overlay for texture */}
      <div className="grain-overlay" />
      
      <FavoritesProvider>
        <BrowserRouter>
          <div className="safe-bottom pb-24">
            <Routes>
              <Route path="/" element={<HomePage zipCode={zipCode} setZipCode={setZipCode} />} />
              <Route path="/launches" element={<LaunchesPage />} />
              <Route path="/launches/:id" element={<LaunchDetailPage zipCode={zipCode} />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/iss" element={<ISSPage />} />
              <Route path="/moon" element={<MoonPage zipCode={zipCode} />} />
              <Route path="/weather" element={<WeatherPage zipCode={zipCode} setZipCode={setZipCode} />} />
              <Route path="/watchlist" element={<WatchlistPage />} />
            </Routes>
          </div>
          <MobileNav />
        </BrowserRouter>
      </FavoritesProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
